import password_logo from "../../login/img/sat-logo.svg";
import close_icon from "./img/majesticons_close.svg";
import qr_image from "./img/login-qr.png";
import { useEffect, useState } from "react";
import { twJoin } from "tailwind-merge";
import styles from "./QRForm.module.scss";
import NoticePopup from "../NoticePopup/NoticePopup";
import { logout } from "../../app/services/auth.service";
import { NavLink, useNavigate } from "react-router-dom";
import { useGetProfileInfoDataQuery } from "../../app/services/profile";
import { useTranslation, withTranslation } from "react-i18next";
import { T } from "lodash/fp";
import { change_axios_language } from "../../app/services/api";
import { LoadingIcon } from "../common/Icons";
import { CircularProgress } from "@mui/material";
const BusinessCard = (props: any) => {
    const { logoData } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { data: profile, isLoading } = useGetProfileInfoDataQuery();
    const [employeeID, setEmployeeID] = useState<string>('');
    const [name, setName] = useState<string>('');
    const [position, setPosition] = useState<string>('');
    const [qr_in,setQRIn]=useState<string>('');
    useEffect(() => {
        if (profile) {
            const pData: any = profile;
            setQRIn(pData?.employee?.qr_in_code);
            setEmployeeID(pData?.employee?.employeeID)
            setName(pData?.employee?.name)
            setPosition(pData?.employee?.jobTitle)
        }
    }, [profile])
    useEffect(() => {
        change_axios_language();
    }, [])
    return (
        <div className={twJoin("max-w-full h-[92vh] overflow-hidden bg-white md:max-w-[360px] mx-auto")}>
            <div className="max-w-full mx-auto">
                <div className="change-password-container px-5 ">
                    <div className="py-5 relative left-0 w-full top-0 bg-white">
                        <h3 className="heading2 font-secondary text-center text-sat_darkblackv2 w-full">
                            {t("my_business_card")}
                        </h3>
                        <NavLink to={{pathname:'/home'}} className="absolute right-0 top-1/2 -translate-y-1/2">
                            <img src={close_icon} alt="back" className="" />
                        </NavLink>
                    </div>
                    <div className="pt-8 pb-8 h-auto flex flex-col justify-between">
                        <div>
                            <div className="mt-5 max-w-[264px] mx-auto">
                                {isLoading?<CircularProgress/>:<div className="border border-sat_border rounded-[20px] bg-white p-5 block w-full shadow-[0_4px_4px_0_gba(0,0,0,0.08)]">
                                    <div>
                                        <div className="text-left mt-3 flex items-center justify-between">
                                            <div>
                                                <p className="heading1 text-sat_darkblackv2 font-bold leading-[135%]">
                                                    {name}
                                                </p>
                                                <p className="text-button text-sat_darkgray400 font-normal leading-[150%]">
                                                    {employeeID}
                                                </p>
                                                <p className="heading2 text-sat_darkblackv2 font-normal mt-1 leading-[nomal]">
                                                    {position}
                                                </p>
                                            </div>
                                        </div>
                                        {qr_in && <div className="mt-5">
                                            <img
                                                src={qr_in}
                                                alt="qr_image"
                                                className="max-w-full object-cover w-full mx-auto border-4 border-sat_borderv2 rounded-xl aspect-[196/196] p-[14px]"
                                            />
                                            <div className="mt-3 text-button font-normal text-center leading-[150%] text-sat_darkgray400">
                                                Scan QR Code to Save Contact
                                            </div>
                                        </div>}
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default withTranslation('common')(BusinessCard);
